import React from 'react';

type Props = {
  location: string;
  timeframe: string;
  sum?: number;
  isProductionData: boolean;
  contractFromId: { address: string };
  unit: string;
};

const GraphTitle: React.FunctionComponent<Props> = (props: Props) => {
  const { location, timeframe, sum, contractFromId, unit } = props;

  const contract = contractFromId;
  const isCompany = window.location.pathname.includes('yritys');

  return (
    <div className={`graph-title${isCompany ? ' lower-placement' : ''}`}>
      {!isCompany ? (
        <text className="graph-usage-unit" textAnchor="middle">
          {unit}
        </text>
      ) : null}

      <text className={`graph-period${isCompany ? ' larger-font' : ''}`} textAnchor="middle">
        {timeframe}
      </text>

      {!isCompany && (
        <text className="graph-location" textAnchor="middle">
          {contract ? contract.address : location}
        </text>
      )}

      {!isCompany && sum && (
        <text className="graph-sum" textAnchor="end">
          {sum} {unit}
        </text>
      )}
    </div>
  );
};

export default GraphTitle;
